import React, { useState, useEffect, useRef } from 'react';
import { FiFilter, FiRotateCw, FiPlus, FiSearch, FiChevronDown, FiEdit, FiTrash2 } from "react-icons/fi";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import { format } from "date-fns";
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { addDriver, getAllDriver, getVehicleFleetForDriver6, deleteDriver, updateDriver, updateDriverStatus } from '../../ApiController/ApiService';
import { useTranslation } from 'react-i18next';
import { useDashboard } from '../Context/Dashboardcontext';
import { toast, ToastContainer } from 'react-toastify';
import ShipmentCard from './ShipmentCard';
import { uploadFileToFirebase } from '../../Utils/uploadFileToFirebase';

const OrdersContainers = () => {
    const { t } = useTranslation();
    const { FetchProfile, userProfile, uploadDocumentDriver, FetchAllIncidentReports, allIncidentReports, FetchAllITrucks, allTrucks } = useDashboard();

    const [showCalendar, setShowCalendar] = useState(false);
    const [selectedDates, setSelectedDates] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [showDropdown, setShowDropdown] = useState(false);
    const [showDropdown2, setShowDropdown2] = useState(false);
    const [selectedRegions, setSelectedRegions] = useState([]);
    const [selectedRegions1, setSelectedRegions1] = useState([]);

    const [isEditMode, setIsEditMode] = useState(false);
    const [currentDriverId, setCurrentDriverId] = useState(null);
    const [originalData, setOriginalData] = useState(null);

    const dropdownRef = useRef(null);
    const dropdownRef2 = useRef(null);
    const calendarRef = useRef(null);
    const buttonRef = useRef(null);
    const buttonRef2 = useRef(null);
    const buttonRef3 = useRef(null);
    const navigate = useNavigate();
    const [drivers2, setDrivers2] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [vehicles, setVehicles] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const [isMobileFilterOpen, setIsMobileFilterOpen] = useState(false);

    const initialFormState = {
        fullName: '',
        Id: '',
        mobileNumber: '',
        email: '',
        address: '',
        password: '',
        truckId: '',          // ✅ truckId (truck ka _id)
        truckSize: '',        // e.g. "53 ft"
        maxCapacity: '',      // e.g. 5000
        drivingLicense: null,
        nationalId: null,
        medicalClearance: null,
        backgroundCheck: null,
        insurancePolicy: null,
        isInsuranceExpired: false,
        insuranceExpiryDate: null,
        userStatus: 'Active',
    };

    const [formData, setFormData] = useState(initialFormState);

    useEffect(() => {
        FetchProfile();
        FetchAllIncidentReports();
        FetchAllITrucks();
    }, []);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const fetchVehicles = async () => {
        try {
            const data = await getVehicleFleetForDriver6();
            if (data.data && Array.isArray(data.data)) {
                setVehicles(data.data);
            }
        } catch (err) {
            console.error('Fetch error:', err);
        }
    };

    const fetchDrivers = async () => {
        try {
            const data = await getAllDriver();
            if (data?.data?.docs) {
                setDrivers2(data.data.docs);
            }
        } catch (err) {
            console.error('Fetch error:', err);
        }
    };

    useEffect(() => {
        const loadData = async () => {
            setIsLoading(true);
            await Promise.all([fetchVehicles(), fetchDrivers()]);
            setIsLoading(false);
        };
        loadData();
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleTruckChange = (e) => {
        const selectedId = e.target.value;
        const selectedTruck = allTrucks?.docs?.find((t) => t._id === selectedId);
        setFormData((prev) => ({
            ...prev,
            truckId: selectedId,
            maxCapacity: selectedTruck?.maximumLoad || prev.maxCapacity,
        }));
    };

    const handleFileChange = (e) => {
        const { name, files } = e.target;
        if (files && files[0]) {
            setFormData((prev) => ({ ...prev, [name]: files[0] }));
        }
    };

    const getPreviewUrl = (fileOrUrl) => {
        if (!fileOrUrl) return null;
        if (typeof fileOrUrl === 'string') return fileOrUrl;
        return URL.createObjectURL(fileOrUrl);
    };

    const resetForm = () => {
        setFormData(initialFormState);
        setOriginalData(null);
        setIsEditMode(false);
        setCurrentDriverId(null);
        setIsModalOpen(false);
    };

    const handleDeleteDriver = async (driverId) => {
        const result = await Swal.fire({
            title: t("driverManagement.alerts.deleteConfirmTitle") || "Are you sure?",
            text: t("driverManagement.alerts.deleteConfirmText") || "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: t("driverManagement.alerts.deleteConfirmButton") || "Yes, delete it!"
        });

        if (result.isConfirmed) {
            try {
                await deleteDriver(driverId);
                await Swal.fire(
                    t("driverManagement.alerts.deletedTitle") || "Deleted!",
                    t("driverManagement.alerts.deletedText") || "Driver has been removed.",
                    "success"
                );
                fetchDrivers();
            } catch (error) {
                console.error("Delete failed", error);
                Swal.fire("Error", "Failed to delete driver", "error");
            }
        }
    };

    const handleStatusChange = async (driverId, newStatus) => {
        try {
            await updateDriverStatus(driverId, newStatus);
            toast.success(`Driver status updated to ${newStatus}`);
            fetchDrivers();
        } catch (err) {
            toast.error(err?.message || 'Failed to update driver status');
        }
    };

    const handleEditDriver = (driver) => {
        setIsEditMode(true);
        setCurrentDriverId(driver._id);

        const dataToLoad = {
            fullName: driver.fullName || '',
            Id: driver.Id || '',
            mobileNumber: driver.mobileNumber || '',
            email: driver.email || '',
            address: driver.address || '',
            password: '',
            truckId: driver.truckId || '',
            truckSize: driver.truckSize || '',
            maxCapacity: driver.maxCapacity || '',
            drivingLicense: driver.drivingLicense || null,
            nationalId: driver.nationalId || null,
            medicalClearance: driver.medicalClearance || null,
            backgroundCheck: driver.backgroundCheck || null,
            insurancePolicy: driver.insurancePolicy || null,
            isInsuranceExpired: driver.isInsuranceExpired || false,
            insuranceExpiryDate: driver.insuranceExpiryDate || null,
            userStatus: driver.userStatus || 'Active',
        };

        setFormData(dataToLoad);
        setOriginalData(dataToLoad);
        setIsModalOpen(true);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        const requiredFields = ["fullName", "Id", "mobileNumber", "email", "address", "truckId"];
        if (!isEditMode) requiredFields.push("password");

        for (let field of requiredFields) {
            if (!formData[field] || formData[field] === "") {
                await Swal.fire({
                    icon: "warning",
                    title: t("driverManagement.alerts.missingFieldTitle"),
                    text: `${field} ${t("driverManagement.alerts.missingFieldMessage")}`,
                    confirmButtonColor: "#6F1AFF",
                });
                setIsSubmitting(false);
                return;
            }
        }

        try {
            let driverId = currentDriverId;

            const basicData = new FormData();
            let hasChanges = false;

            Object.entries(formData).forEach(([key, value]) => {
                const isFileField = ["drivingLicense", "nationalId", "medicalClearance", "backgroundCheck", "insurancePolicy"].includes(key);

                if (!isFileField) {
                    if (isEditMode) {
                        if (key === 'password') {
                            if (value !== '') { basicData.append(key, value); hasChanges = true; }
                        } else if (value !== originalData[key]) {
                            basicData.append(key, value);
                            hasChanges = true;
                        }
                    } else {
                        basicData.append(key, value);
                    }
                }
            });

            if (isEditMode) {
                if (hasChanges) await updateDriver(currentDriverId, basicData);
            } else {
                const res = await addDriver(basicData);
                driverId = res?.data?._id;
                if (!driverId) throw new Error("Driver ID not received from API");
            }

            const docFields = ["drivingLicense", "nationalId", "medicalClearance", "backgroundCheck", "insurancePolicy"];
            const filesToUpload = docFields.filter(field => formData[field] && formData[field] instanceof File);

            if (filesToUpload.length > 0) {
                Swal.fire({
                    title: "Uploading Documents...",
                    html: `<div id="progress-container">
                        <p id="progress-text">Starting upload...</p>
                        <div style="width:100%;background:#eee;border-radius:6px;overflow:hidden;">
                          <div id="progress-bar" style="width:0%;height:8px;background:#6F1AFF;"></div>
                        </div>
                      </div>`,
                    allowOutsideClick: false,
                    showConfirmButton: false,
                    didOpen: () => { Swal.showLoading(); },
                });

                const uploadedDocs = {};
                for (let field of filesToUpload) {
                    const file = formData[field];
                    const progressText = document.getElementById("progress-text");
                    const progressBar = document.getElementById("progress-bar");
                    if (progressText) progressText.textContent = `Uploading ${field}...`;
                    try {
                        const downloadURL = await uploadFileToFirebase(file, "driver-documents", (progress) => {
                            if (progressBar) progressBar.style.width = `${progress}%`;
                            if (progressText) progressText.textContent = `${field}: ${progress}%`;
                        });
                        uploadedDocs[field] = downloadURL;
                    } catch (err) {
                        Swal.close();
                        throw new Error(`Failed to upload ${field}`);
                    }
                }

                Swal.close();
                const docPayload = {};
                Object.keys(uploadedDocs).forEach(key => { docPayload[key] = uploadedDocs[key]; });
                await uploadDocumentDriver(driverId, docPayload);
            }

            await Swal.fire({
                icon: "success",
                title: t("driverManagement.alerts.successTitle"),
                text: isEditMode ? "Driver updated successfully" : t("driverManagement.alerts.successMessage"),
                confirmButtonColor: "#6F1AFF",
            });

            resetForm();
            fetchDrivers();
        } catch (err) {
            await Swal.fire({
                icon: "error",
                title: t("driverManagement.alerts.errorTitle"),
                text: err.message || t("driverManagement.alerts.errorMessage"),
                confirmButtonColor: "#6F1AFF",
            });
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleAddDriverPopuo = () => {
               const hasNormalPackage = !!userProfile?.packageId;
        const hasAiPackage = userProfile?.aiPackageId?._id;
 
        if (!hasNormalPackage && !hasAiPackage) {
            toast.error("Please purchase a package to add drivers.");
            return;
        }
 
   
        // if (hasNormalPackage) {
        //     const totalAllowedDrivers = userProfile?.packageId?.fleetSizeDriver ?? 0;
        //     const currentDrivers = userProfile?.totalDriver ?? 0;
        //     if (totalAllowedDrivers > 0 && currentDrivers >= totalAllowedDrivers) {
        //         toast.error(t("driverManagement.maxDriverLimitReached", { limit: totalAllowedDrivers }));
        //         return;
        //     }
        // }
 
    
        // if (!hasNormalPackage && !hasAiPackage) {
        //     toast.error("Your AI package has expired. Please renew to add drivers.");
        //     return;
        // }
        setFormData({
            ...initialFormState,
            Id: `DRV-${Math.floor(100000 + Math.random() * 900000)}`
        });
        setOriginalData(null);
        setIsEditMode(false);
        setIsModalOpen(true);
    };
console.log("allTrucks",allTrucks)
    const handleCalendarToggle = () => setShowCalendar((prev) => !prev);
    const toggleRegion = (region) => setSelectedRegions(prev => prev.includes(region) ? prev.filter(r => r !== region) : [...prev, region]);
    const toggleRegion2 = (region1) => setSelectedRegions1(prev => prev.includes(region1) ? prev.filter(r => r !== region1) : [...prev, region1]);

    const regionKeys = ["africa", "uk", "america", "caribbean", "usa", "eu", "canada", "australia"];
    const statusKeys = ["delivered", "inTransit", "delayed"];

    return (
        <div className="text-white relative px-2 md:px-0">
            {/* Header */}
            <div className="flex flex-col md:flex-row md:items-center justify-between mb-6 gap-4">
                <h1 className="text-2xl font-semibold">{t('driverManagement.header')}</h1>
            </div>

            {/* Filter Section */}
            {isMobile ? (
                <div className="w-full mb-6">
                    <button onClick={() => setIsMobileFilterOpen(!isMobileFilterOpen)} className="w-full flex items-center justify-between bg-[#10194E] rounded-xl shadow-md p-4">
                        <div className="flex items-center gap-2 text-white">
                            <FiFilter className="text-lg" />
                            <span className="text-sm">{t('driverManagement.filters.filterBy')}</span>
                        </div>
                        <FiChevronDown className={`text-white transition-transform ${isMobileFilterOpen ? 'rotate-180' : ''}`} />
                    </button>

                    {isMobileFilterOpen && (
                        <div className="mt-2 bg-[#10194E] rounded-xl p-4 space-y-4">
                            <div className="relative">
                                <button ref={buttonRef} onClick={handleCalendarToggle} className="w-full px-4 py-3 text-sm text-white border border-[#1E2A60] bg-transparent rounded-lg flex justify-between items-center">
                                    <span>{selectedDates.length > 0 ? selectedDates.map((date) => format(date, "PP")).join(", ") : t('driverManagement.filters.date')}</span>
                                    <FiChevronDown />
                                </button>
                                {showCalendar && (
                                    <div ref={calendarRef} className="absolute left-0 right-0 mt-1 p-4 shadow-lg rounded z-50" style={{ background: 'radial-gradient(50% 49.39% at 50% 50%, #1D2461 0%, #080625 100%)' }}>
                                        <DayPicker mode="multiple" selected={selectedDates} onSelect={setSelectedDates}
                                            footer={
                                                <div className="pt-4">
                                                    <div className="flex justify-start"><span className="text-sm text-gray-400">{t('driverManagement.filters.dateTooltip')}</span></div>
                                                    <div className="flex justify-center mt-2"><button onClick={() => setShowCalendar(false)} className="bg-[#6F1AFF] text-white px-4 py-1 rounded">{t('driverManagement.filters.apply')}</button></div>
                                                </div>
                                            }
                                        />
                                    </div>
                                )}
                            </div>

                            <div className="relative">
                                <button ref={buttonRef2} onClick={() => setShowDropdown(!showDropdown)} className="w-full bg-transparent text-white px-4 py-3 text-sm border border-[#1E2A60] outline-none rounded-lg flex justify-between items-center">
                                    <span>{t('driverManagement.filters.location')}</span>
                                    <FiChevronDown />
                                </button>
                                {showDropdown && (
                                    <div ref={dropdownRef} style={{ background: 'radial-gradient(50% 49.39% at 50% 50%, #1D2461 0%, #080625 100%)' }} className="absolute left-0 right-0 mt-1 w-full text-white rounded-2xl p-4 z-50 shadow-lg">
                                        <h2 className="text-lg font-semibold mb-4">{t('driverManagement.filters.locationTitle')}</h2>
                                        <div className="grid grid-cols-2 gap-3 mb-4">
                                            {regionKeys.map((key) => (
                                                <button key={key} onClick={() => toggleRegion(key)} className={`px-3 py-2 rounded-full border transition-all text-sm ${selectedRegions.includes(key) ? "bg-white text-black font-semibold" : "bg-[#1D2A85] hover:bg-[#2A3AA5]"}`}>
                                                    {t(`driverManagement.locations.${key}`)}
                                                </button>
                                            ))}
                                        </div>
                                        <p className="text-sm text-gray-300 mb-3">{t('driverManagement.filters.locationTooltip')}</p>
                                        <div className="text-center"><button onClick={() => setShowDropdown(false)} className="bg-gradient-to-r from-[#6E00FF] to-[#A627FF] px-6 py-2 rounded-lg text-white font-semibold hover:opacity-90">{t('driverManagement.filters.applyNow')}</button></div>
                                    </div>
                                )}
                            </div>

                            <div className="relative">
                                <button ref={buttonRef3} onClick={() => setShowDropdown2(!showDropdown2)} className="w-full bg-transparent text-white px-4 py-3 text-sm border border-[#1E2A60] outline-none rounded-lg flex justify-between items-center">
                                    <span>{t('driverManagement.filters.status')}</span>
                                    <FiChevronDown />
                                </button>
                                {showDropdown2 && (
                                    <div ref={dropdownRef2} style={{ background: 'radial-gradient(50% 49.39% at 50% 50%, #1D2461 0%, #080625 100%)' }} className="absolute left-0 right-0 mt-1 w-full text-white rounded-2xl p-4 z-50 shadow-lg">
                                        <h2 className="text-lg font-semibold mb-4">{t('driverManagement.filters.statusTitle')}</h2>
                                        <div className="grid grid-cols-2 gap-3 mb-4">
                                            {statusKeys.map((key) => (
                                                <button key={key} onClick={() => toggleRegion2(key)} className={`px-3 py-2 rounded-full border transition-all text-sm ${selectedRegions1.includes(key) ? "bg-white text-black font-semibold" : "bg-[#1D2A85] hover:bg-[#2A3AA5]"}`}>
                                                    {t(`driverManagement.statuses.${key}`)}
                                                </button>
                                            ))}
                                        </div>
                                        <p className="text-sm text-gray-300 mb-3">{t('driverManagement.filters.statusTooltip')}</p>
                                        <div className="text-center"><button onClick={() => setShowDropdown2(false)} className="bg-gradient-to-r from-[#6E00FF] to-[#A627FF] px-6 py-2 rounded-lg text-white font-semibold hover:opacity-90">{t('driverManagement.filters.applyNow')}</button></div>
                                    </div>
                                )}
                            </div>
                            <button className="w-full flex items-center justify-center gap-1 px-4 py-3 text-sm text-orange-400 hover:underline border border-[#1E2A60] rounded-lg">
                                <FiRotateCw className="text-sm" />
                                {t('driverManagement.filters.reset')}
                            </button>
                        </div>
                    )}
                </div>
            ) : (
                <div className="flex items-center justify-between mb-6">
                    <div className="relative flex items-center bg-[#10194E] rounded-xl shadow-md"></div>
                    <button onClick={handleAddDriverPopuo} className="ml-4 bg-gradient-to-r from-[#6E00FF] to-[#A627FF] hover:opacity-90 px-5 py-2 rounded-xl text-white font-medium flex items-center gap-2 shadow-md">
                        <FiPlus className="text-md" />
                        {t('driverManagement.addNewDriverButton')}
                    </button>
                </div>
            )}

            {/* Add/Edit Driver Modal */}
            {isModalOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[999] p-4">
                    <div className="rounded-xl shadow-xl text-white p-6 relative w-full max-w-[480px] max-h-[90vh] overflow-y-auto hide-scrollbar"
                        style={{ background: "radial-gradient(50% 49.39% at 50% 50%, #1D2461 0%, #080625 100%)" }}>
                        <button onClick={resetForm} className="absolute top-3 right-4 text-white text-xl font-bold hover:text-gray-300" aria-label="Close">&times;</button>
                        <h2 className="text-2xl font-bold mb-4">
                            {isEditMode ? t("driverManagement.driverForm.modalTitleEdit") : t("driverManagement.driverForm.modalTitle")}
                        </h2>

                        <form onSubmit={handleSubmit}>
                            {/* Driver Name */}
                            <div className="mb-4">
                                <label className="block text-sm font-semibold mb-2">{t("driverManagement.driverForm.driverNameLabel")}</label>
                                <input type="text" name="fullName" value={formData.fullName} onChange={handleInputChange} className="w-full rounded px-3 py-2 text-black" placeholder={t("driverManagement.driverForm.driverNamePlaceholder")} required />
                            </div>

                            {/* Driver ID */}
                            <div className="mb-4">
                                <label className="block text-sm font-semibold mb-2">{t("driverManagement.driverForm.driverIdLabel")}</label>
                                <input 
                                    type="text" 
                                    name="Id" 
                                    value={formData.Id} 
                                    readOnly
                                    className="w-full rounded px-3 py-2 bg-gray-200 text-gray-500 cursor-not-allowed" 
                                    placeholder={t("driverManagement.driverForm.driverIdPlaceholder")} 
                                    required 
                                />
                            </div>

                            {/* ✅ Truck Dropdown — only active trucks */}
                            <div className="mb-4">
                                <label className="block text-sm font-semibold mb-2">
                                    {t("driverManagement.driverForm.truckNumberLabel")}
                                </label>
                                <select
                                    name="truckId"
                                    value={formData.truckId}
                                    onChange={handleTruckChange}
                                    className="w-full rounded px-3 py-2 text-black"
                                    required
                                >
                                    <option value="">-- Select Truck --</option>
                                    {allTrucks?.docs
                                        ?.filter((truck) => truck.status === "active")
                                        .map((truck) => (
                                            <option key={truck._id} value={truck._id}>
                                                {[
                                                    truck.licenseNumber || truck.companyName || truck._id,
                                                    truck.maximumLoad ? `(Max Load: ${truck.maximumLoad} lbs)` : ''
                                                ].filter(Boolean).join(' ')}
                                            </option>
                                        ))}
                                </select>
                            </div>

                            {/* Truck Size — dropdown + manual entry */}
                            <div className="mb-4">
                                <label className="block text-sm font-semibold mb-2">Truck Size</label>
                                <input
                                    type="text"
                                    name="truckSize"
                                    value={formData.truckSize}
                                    onChange={handleInputChange}
                                    list="truckSizeOptions"
                                    className="w-full rounded px-3 py-2 text-black"
                                    placeholder="Select or type (e.g. 53 ft)"
                                    required
                                />
                                <datalist id="truckSizeOptions">
                                    <option value="20 ft" />
                                    <option value="24 ft" />
                                    <option value="28 ft" />
                                    <option value="32 ft" />
                                    <option value="40 ft" />
                                    <option value="48 ft" />
                                    <option value="53 ft" />
                                </datalist>
                            </div>

                            {/* Max Capacity */}
                            <div className="mb-4">
                                <label className="block text-sm font-semibold mb-2">Max Capacity (lbs)</label>
                                <input
                                    type="number"
                                    name="maxCapacity"
                                    value={formData.maxCapacity}
                                    onChange={handleInputChange}
                                    className="w-full rounded px-3 py-2 text-black"
                                    placeholder="e.g. 5000"
                                    min="0"
                                    required
                                />
                            </div>

                            {/* Mobile Number */}
                            <div className="mb-4">
                                <label className="block text-sm font-semibold mb-2">{t("driverManagement.driverForm.mobileNumberLabel")}</label>
                                <input type="text" name="mobileNumber" value={formData.mobileNumber} onChange={handleInputChange} className="w-full rounded px-3 py-2 text-black" placeholder={t("driverManagement.driverForm.mobileNumberPlaceholder")} required />
                            </div>

                            {/* Email */}
                            <div className="mb-4">
                                <label className="block text-sm font-semibold mb-2">{t("driverManagement.driverForm.emailLabel")}</label>
                                <input type="email" name="email" value={formData.email} onChange={handleInputChange} className="w-full rounded px-3 py-2 text-black" placeholder={t("driverManagement.driverForm.emailPlaceholder")} required />
                            </div>

                            {/* Address */}
                            <div className="mb-4">
                                <label className="block text-sm font-semibold mb-2">{t("driverManagement.driverForm.addressLabel")}</label>
                                <input type="text" name="address" value={formData.address} onChange={handleInputChange} className="w-full rounded px-3 py-2 text-black" placeholder={t("driverManagement.driverForm.addressPlaceholder")} required />
                            </div>

                            {/* Password */}
                            <div className="mb-4">
                                <label className="block text-sm font-semibold mb-2">
                                    {t("driverManagement.driverForm.passwordLabel")}
                                    {isEditMode && <span className="text-xs text-gray-400 font-normal ml-2">(Leave blank to keep current)</span>}
                                </label>
                                <input type="password" name="password" value={formData.password} onChange={handleInputChange} className="w-full rounded px-3 py-2 text-black" placeholder={t("driverManagement.driverForm.passwordPlaceholder")} required={!isEditMode} />
                            </div>

                            {/* User Status */}
                            <div className="mb-4">
                                <label className="block text-sm font-semibold mb-2">Account Status</label>
                                <label className="relative inline-flex items-center cursor-pointer">
                                    <input 
                                        type="checkbox" 
                                        className="sr-only peer" 
                                        checked={formData.userStatus === 'Active'} 
                                        onChange={(e) => handleInputChange({ target: { name: 'userStatus', value: e.target.checked ? 'Active' : 'Block' } })} 
                                    />
                                    <div className="w-11 h-6 bg-gray-600 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-[#00B69B]"></div>
                                    <span className="ml-3 text-sm font-medium text-white">{formData.userStatus === 'Active' ? 'Active' : 'Block'}</span>
                                </label>
                            </div>

                            {/* Driving License */}
                            <div className="mb-6">
                                <label className="block text-sm font-semibold mb-2">{t("driverManagement.driverForm.drivingLicenseLabel")}</label>
                                <div className="bg-white rounded-lg p-4">
                                    {formData.drivingLicense ? (
                                        <img src={getPreviewUrl(formData.drivingLicense)} alt={t("driverManagement.driverForm.drivingLicenseLabel")} className="w-full h-40 object-cover rounded" />
                                    ) : (
                                        <div className="w-full h-40 bg-gray-200 rounded flex items-center justify-center text-gray-500 text-sm">
                                            {isEditMode ? "Upload to replace existing file" : t("driverManagement.driverForm.noFileChosen")}
                                        </div>
                                    )}
                                    <label className="mt-4 block cursor-pointer">
                                        <input type="file" name="drivingLicense" onChange={handleFileChange} className="hidden" />
                                        <div className="mt-2 text-center bg-purple-600 text-white py-2 rounded hover:bg-purple-700">{t("driverManagement.driverForm.upload")}</div>
                                    </label>
                                </div>
                            </div>

                            {/* National ID */}
                            <div className="mb-6">
                                <label className="block text-sm font-semibold mb-2">{t("driverManagement.driverForm.nationalIdLabel")}</label>
                                <div className="bg-white rounded-lg p-4">
                                    {formData.nationalId ? (
                                        <img src={getPreviewUrl(formData.nationalId)} alt={t("driverManagement.driverForm.nationalIdLabel")} className="w-full h-40 object-cover rounded" />
                                    ) : (
                                        <div className="w-full h-40 bg-gray-200 rounded flex items-center justify-center text-gray-500 text-sm">
                                            {isEditMode ? "Upload to replace existing file" : t("driverManagement.driverForm.noFileChosen")}
                                        </div>
                                    )}
                                    <label className="mt-4 block cursor-pointer">
                                        <input type="file" name="nationalId" onChange={handleFileChange} className="hidden" />
                                        <div className="mt-2 text-center bg-purple-600 text-white py-2 rounded hover:bg-purple-700">{t("driverManagement.driverForm.upload")}</div>
                                    </label>
                                </div>
                            </div>

                            {/* Medical Clearance */}
                            <div className="mb-6">
                                <label className="block text-sm font-semibold mb-2">{t("driverManagement.driverForm.medicalClearanceLabel")}</label>
                                <div className="bg-white rounded-lg p-4">
                                    {formData.medicalClearance ? (
                                        <img src={getPreviewUrl(formData.medicalClearance)} alt={t("driverManagement.driverForm.medicalClearanceLabel")} className="w-full h-40 object-cover rounded" />
                                    ) : (
                                        <div className="w-full h-40 bg-gray-200 rounded flex items-center justify-center text-gray-500 text-sm">
                                            {isEditMode ? "Upload to replace existing file" : t("driverManagement.driverForm.noFileChosen")}
                                        </div>
                                    )}
                                    <label className="mt-4 block cursor-pointer">
                                        <input type="file" name="medicalClearance" onChange={handleFileChange} className="hidden" />
                                        <div className="mt-2 text-center bg-purple-600 text-white py-2 rounded hover:bg-purple-700">{t("driverManagement.driverForm.upload")}</div>
                                    </label>
                                </div>
                            </div>

                            {/* Background Check */}
                            <div className="mb-6">
                                <label className="block text-sm font-semibold mb-2">{t("driverManagement.driverForm.backgroundCheckLabel")}</label>
                                <div className="bg-white rounded-lg p-4">
                                    {formData.backgroundCheck ? (
                                        <img src={getPreviewUrl(formData.backgroundCheck)} alt={t("driverManagement.driverForm.backgroundCheckLabel")} className="w-full h-40 object-cover rounded" />
                                    ) : (
                                        <div className="w-full h-40 bg-gray-200 rounded flex items-center justify-center text-gray-500 text-sm">
                                            {isEditMode ? "Upload to replace existing file" : t("driverManagement.driverForm.noFileChosen")}
                                        </div>
                                    )}
                                    <label className="mt-4 block cursor-pointer">
                                        <input type="file" name="backgroundCheck" onChange={handleFileChange} className="hidden" />
                                        <div className="mt-2 text-center bg-purple-600 text-white py-2 rounded hover:bg-purple-700">{t("driverManagement.driverForm.upload")}</div>
                                    </label>
                                </div>
                            </div>

                            {/* Insurance Policy Details */}
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                                <div>
                                    <label className="block text-sm font-semibold mb-2">Insurance Expiry Date</label>
                                    <input 
                                        type="date" 
                                        name="insuranceExpiryDate" 
                                        value={formData.insuranceExpiryDate ? formData.insuranceExpiryDate.substring(0, 10) : ''} 
                                        onChange={(e) => {
                                            const dateVal = e.target.value;
                                            const isExpired = dateVal ? new Date(dateVal) < new Date(new Date().setHours(0,0,0,0)) : false;
                                            setFormData(prev => ({ 
                                                ...prev, 
                                                insuranceExpiryDate: dateVal,
                                                isInsuranceExpired: isExpired
                                            }));
                                        }} 
                                        className="w-full rounded px-3 py-2 text-black" 
                                    />
                                </div>
                                <div className="flex items-center mt-6">
                                    <input 
                                        type="checkbox" 
                                        name="isInsuranceExpired" 
                                        checked={formData.isInsuranceExpired} 
                                        disabled
                                        className="w-4 h-4 text-purple-600 bg-gray-100 border-gray-300 rounded opacity-50 cursor-not-allowed" 
                                    />
                                    <label className="ml-2 text-sm font-semibold text-gray-400">Insurance is Expired</label>
                                </div>
                            </div>

                            {/* Insurance Policy */}
                            <div className="mb-6">
                                <label className="block text-sm font-semibold mb-2">Insurance Policy</label>
                                {formData.insuranceExpiryDate && (
                                    <div className={`mb-3 p-3 rounded text-sm ${formData.isInsuranceExpired ? 'bg-red-900/30 border border-red-800 text-red-200' : 'bg-green-900/30 border border-green-800 text-green-200'}`}>
                                        <div className="font-semibold">{formData.isInsuranceExpired ? '⚠️ Insurance Expired' : '✅ Insurance Active'}</div>
                                        <div>Expiry Date: {new Date(formData.insuranceExpiryDate).toLocaleDateString()}</div>
                                    </div>
                                )}
                                <div className="bg-white rounded-lg p-4">
                                    {formData.insurancePolicy ? (
                                        <img src={getPreviewUrl(formData.insurancePolicy)} alt="Insurance Policy" className="w-full h-40 object-cover rounded" />
                                    ) : (
                                        <div className="w-full h-40 bg-gray-200 rounded flex items-center justify-center text-gray-500 text-sm">
                                            {isEditMode ? "Upload to replace existing file" : t("driverManagement.driverForm.noFileChosen")}
                                        </div>
                                    )}
                                    <label className="mt-4 block cursor-pointer">
                                        <input type="file" name="insurancePolicy" onChange={handleFileChange} className="hidden" />
                                        <div className="mt-2 text-center bg-purple-600 text-white py-2 rounded hover:bg-purple-700">{t("driverManagement.driverForm.upload")}</div>
                                    </label>
                                </div>
                            </div>

                            <button type="submit" className="mt-6 w-full bg-[#792aff] text-white py-2 rounded-md font-semibold flex items-center justify-center" disabled={isSubmitting}>
                                {isSubmitting ? (
                                    <>
                                        <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                        </svg>
                                        {t("driverManagement.driverForm.submitting")}
                                    </>
                                ) : (
                                    isEditMode ? "Update Driver" : t("driverManagement.driverForm.submit")
                                )}
                            </button>
                        </form>
                    </div>
                </div>
            )}

            {/* Driver Table */}
            <div className="overflow-x-auto bg-[#1D2461] rounded-lg mt-4">
                <div className="min-w-[800px] md:min-w-0">
                    <table className="w-full table-auto text-sm text-left">
                        <thead className="bg-[#B2BAFF] text-[#202224] font-nunito uppercase text-[14px]">
                            <tr>
                                <th className="p-4"><input type="checkbox" /></th>
                                <th className="p-4">{t('driverManagement.driverTable.headers.name')}</th>
                                <th className="p-4">{t('driverManagement.driverTable.headers.driverId')}</th>
                                <th className="p-4">{t('driverManagement.driverTable.headers.phone')}</th>
                                <th className="p-4">{t('driverManagement.driverTable.headers.truckNumber')}</th>
                                <th className="p-4">Insurance</th>
                                <th className="p-4">{t('driverManagement.driverTable.headers.status')}</th>
                                <th className="p-4">{t('driverManagement.driverTable.headers.assignedTrips')}</th>
                                <th className="p-4">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {isLoading ? (
                                <tr>
                                    <td colSpan="9" className="p-8 text-center">
                                        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-white mx-auto"></div>
                                    </td>
                                </tr>
                            ) : drivers2.length > 0 ? (
                                drivers2.map((driver2) => (
                                    <tr key={driver2._id} className="border-t border-[#2A2A4D]">
                                        <td className="p-4"><input type="checkbox" /></td>
                                        <td className="p-4 text-start"><span className="text-white text-sm">{driver2.fullName || 'N/A'}</span></td>
                                        <td className="p-4">{driver2.Id || 'N/A'}</td>
                                        <td className="p-4">{driver2.mobileNumber || 'N/A'}</td>
                                        <td className="p-4">{driver2.truckId || 'N/A'}</td>
                                        <td className="p-4">
                                            {driver2.isInsuranceExpired ? (
                                                <span className="bg-red-900 text-red-300 text-[11px] font-bold px-2 py-1 rounded-full whitespace-nowrap">EXPIRED</span>
                                            ) : driver2.insuranceExpiryDate ? (
                                                <span className="bg-green-900 text-green-300 text-[11px] font-bold px-2 py-1 rounded-full whitespace-nowrap">ACTIVE</span>
                                            ) : (
                                                <span className="text-gray-500 text-xs">—</span>
                                            )}
                                        </td>
                                        <td className="p-4">
                                            <label className="relative inline-flex items-center cursor-pointer">
                                                <input 
                                                    type="checkbox" 
                                                    className="sr-only peer" 
                                                    checked={driver2.userStatus === 'Active' || driver2.userStatus == null} 
                                                    onChange={(e) => handleStatusChange(driver2._id, e.target.checked ? 'Active' : 'Block')} 
                                                />
                                                <div className="w-9 h-5 bg-gray-600 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-[#00B69B]"></div>
                                                <span className="ml-2 text-xs font-medium text-white">{driver2.userStatus === 'Active' || driver2.userStatus == null ? 'Active' : 'Block'}</span>
                                            </label>
                                        </td>
                                        <td className="p-4">{driver2.totalTrip || 0}</td>
                                        <td className="p-4 flex gap-3">
                                            <button onClick={() => handleEditDriver(driver2)} className="text-blue-400 hover:text-blue-200 transition-colors" title="Edit"><FiEdit size={18} /></button>
                                            <button onClick={() => handleDeleteDriver(driver2._id)} className="text-red-400 hover:text-red-200 transition-colors" title="Delete"><FiTrash2 size={18} /></button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr><td colSpan="8" className="p-4 text-center text-white">{t('driverManagement.driverTable.noDrivers')}</td></tr>
                            )}
                        </tbody>
                    </table>
                </div>
                <div className="text-sm text-gray-400 p-4">
                    {t('driverManagement.driverTable.showing', { count: drivers2.length, total: drivers2.length })}
                </div>
            </div>

            {/* Fleet Management Section */}
            <div className="flex items-center justify-between mt-6">
                <h1 className="text-2xl font-semibold">{t('driverManagement.fleetManagement.header')}</h1>
            </div>

            <div className="overflow-x-auto bg-[#1D2461] mt-6 rounded-lg">
                <div className="min-w-[800px] md:min-w-0">
                    <table className="w-full table-auto text-sm text-left">
                        <thead className="bg-[#B2BAFF] text-[#202224] font-nunito uppercase text-[14px]">
                            <tr>
                                <th className="p-4"><input type="checkbox" /></th>
                                <th className="p-4">{t('driverManagement.fleetManagement.table.headers.name')}</th>
                                <th className="p-4">{t('driverManagement.fleetManagement.table.headers.driverId')}</th>
                                <th className="p-4">{t('driverManagement.fleetManagement.table.headers.phone')}</th>
                                <th className="p-4">{t('driverManagement.fleetManagement.table.headers.licenseExpiry')}</th>
                                <th className="p-4">{t('driverManagement.fleetManagement.table.headers.status')}</th>
                                <th className="p-4">{t('driverManagement.fleetManagement.table.headers.assignedTrips')}</th>
                                <th className="p-4">{t('driverManagement.fleetManagement.table.headers.lastTripStatus')}</th>
                                <th className="p-4">{t('driverManagement.fleetManagement.table.headers.actions')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {isLoading ? (
                                <tr>
                                    <td colSpan="9" className="p-8 text-center">
                                        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-white mx-auto"></div>
                                    </td>
                                </tr>
                            ) : vehicles.length > 0 ? (
                                vehicles.map((vehicle, idx) => (
                                    <tr key={idx} className="border-t border-[#2A2A4D]">
                                        <td className="p-4"><input type="checkbox" /></td>
                                        <td className="p-4">{vehicle.name || 'N/A'}</td>
                                        <td className="p-4">{vehicle.driverId || 'N/A'}</td>
                                        <td className="p-4">{vehicle.phoneNumber || 'N/A'}</td>
                                        <td className="p-4">{vehicle.licenseExpiry || 'N/A'}</td>
                                        <td className="p-4">{vehicle.status || 'N/A'}</td>
                                        <td className="p-4">{vehicle.assignedTrips || 0}</td>
                                        <td className="p-4">{vehicle.lastTripStatus || 'N/A'}</td>
                                        <td className="p-4"><button className="bg-[#00B69B] text-white px-4 py-1 rounded-2xl hover:bg-blue-600">{t('driverManagement.fleetManagement.table.viewButton')}</button></td>
                                    </tr>
                                ))
                            ) : (
                                <tr><td colSpan="9" className="p-4 text-center text-white">{t('driverManagement.fleetManagement.table.noVehicles')}</td></tr>
                            )}
                        </tbody>
                    </table>
                </div>
                <div className="text-sm text-gray-400 p-4">
                    {t('driverManagement.fleetManagement.table.showing', { count: vehicles.length, total: vehicles.length })}
                </div>
            </div>

            <ShipmentCard drivers2={drivers2} fetchDrivers={fetchDrivers} />

            <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop={false} closeOnClick pauseOnHover draggable theme="colored" />
        </div>
    );
};

export default OrdersContainers;